export default __webpack_public_path__ + "static/media/logo-white.2b2a61a8.png";